import { render, staticRenderFns } from "./TodoFilter.vue?vue&type=template&id=272602bd&scoped=true"
import script from "./TodoFilter.vue?vue&type=script&lang=js"
export * from "./TodoFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272602bd",
  null
  
)

export default component.exports